import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueGtag from "vue-gtag";
import '/src/assets/scss/main.scss';

Vue.config.productionTip = true;

// Google Analytics via VueGtag
Vue.use(VueGtag, {
  config: { id: "G-BTMZJP2NNL" }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
